import React from 'react';
import { motion } from 'framer-motion';
import { Skull, Link2, KeyRound, FileWarning } from 'lucide-react';
const problems = [{
  icon: <Skull className="w-6 h-6 text-red-400" data-id="element-163" />,
  title: 'Ransomware Incursions',
  description: 'Organizations are losing millions to sophisticated, encrypted extortion campaigns that bypass traditional antivirus.',
  stat: '€1.8M avg. cost'
}, {
  icon: <Link2 className="w-6 h-6 text-orange-400" data-id="element-164" />,
  title: 'Supply Chain Infiltration',
  description: 'Third-party vendors and integrated APIs act as silent attack vectors, compromising your core infrastructure.',
  stat: '62% of breaches'
}, {
  icon: <KeyRound className="w-6 h-6 text-brand-steel" data-id="element-165" />,
  title: 'Credential Harvesting',
  description: 'Phishing and social engineering at scale are bypassing MFA, granting attackers legitimate access to your network.',
  stat: '80% use stolen creds'
}, {
  icon: <FileWarning className="w-6 h-6 text-brand-cyan" data-id="element-166" />,
  title: 'Compliance Drift',
  description: 'Failing to meet stringent GDPR, NIS2, and ISO 27001 standards results in devastating regulatory fines.',
  stat: 'Up to 4% global rev.'
}];
export function ProblemsSection() {
  return <section id="about" className="py-24 bg-brand-dark relative" data-id="element-167">
      <div className="container mx-auto px-6" data-id="element-168">
        <div className="mb-16 max-w-3xl" data-id="element-169">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-mono font-bold text-white mb-4" data-id="element-170">
            <span className="text-brand-steel mr-2" data-id="element-171">/</span>
            The Threat Landscape
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-400 text-lg" data-id="element-172">
            Legacy firewalls and reactive monitoring are obsolete. Attackers are
            already inside the perimeter. Here is what you are up against.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-173">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-darker border border-brand-border p-8 rounded-lg relative overflow-hidden group hover:border-brand-steel/50 transition-colors" data-id="element-174">
              {/* Subtle grid background */}
              <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] opacity-20" data-id="element-175" />

              <div className="relative z-10" data-id="element-176">
                <div className="flex items-center justify-between mb-6" data-id="element-177">
                  <div className="p-3 bg-brand-dark rounded-md border border-brand-border" data-id="element-178">
                    {problem.icon}
                  </div>
                  <span className="font-mono text-xs text-brand-gray bg-brand-dark px-3 py-1 rounded-full border border-brand-border" data-id="element-179">
                    {problem.stat}
                  </span>
                </div>

                <h3 className="text-xl font-mono font-bold text-white mb-3 group-hover:text-brand-steel transition-colors" data-id="element-180">
                  {problem.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-181">
                  {problem.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}